var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.bannerMessage)?_c('v-banner',{staticClass:"white--text",attrs:{"color":"primary"}},[_c('v-container',{staticClass:"pt-1 pb-1",domProps:{"innerHTML":_vm._s(_vm.bannerMessage)}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }